import { AXIOME_REST, AXM_DENOM } from "./types.js";

export async function getNativeBalance(
  address: string,
  denom: string = AXM_DENOM,
  rest: string = AXIOME_REST,
): Promise<string> {
  const url = `${rest.replace(/\/$/, "")}/cosmos/bank/v1beta1/balances/${address}/by_denom?denom=${encodeURIComponent(denom)}`;
  const res = await fetch(url);
  if (!res.ok) {
    const res2 = await fetch(
      `${rest.replace(/\/$/, "")}/cosmos/bank/v1beta1/balances/${address}`,
    );
    if (!res2.ok) throw new Error(`balance query failed: ${res2.status}`);
    const body = await res2.json();
    const coin = (body.balances as { denom: string; amount: string }[] | undefined)?.find(
      (c) => c.denom === denom,
    );
    return coin?.amount ?? "0";
  }
  const body = await res.json();
  return body.balance?.amount ?? body.amount ?? "0";
}

export function shortAddress(addr: string, size = 6): string {
  if (addr.length <= size * 2 + 3) return addr;
  return `${addr.slice(0, size)}…${addr.slice(-size)}`;
}
